import script from "./EnvironmentSqmNewXQ.vue?vue&type=script&setup=true&lang=js"
export * from "./EnvironmentSqmNewXQ.vue?vue&type=script&setup=true&lang=js"

import "./EnvironmentSqmNewXQ.vue?vue&type=style&index=0&id=1a059689&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a059689"]])

export default __exports__